import { render, staticRenderFns } from "./dlxxEnd.vue?vue&type=template&id=0652f1c0&scoped=true"
import script from "./dlxxEnd.vue?vue&type=script&lang=js"
export * from "./dlxxEnd.vue?vue&type=script&lang=js"
import style0 from "./dlxxEnd.vue?vue&type=style&index=0&id=0652f1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0652f1c0",
  null
  
)

export default component.exports